import React, { useCallback, useState } from 'react'
import Modal from '../../components/organisms/Modal/Modal'


type ModalMode = 'successPrompt' | 'errorPrompt';

type PropsType = {
    children: React.ReactNode
    colorful?: boolean
    mode?: ModalMode
    unclosed?: boolean
}

/**
 * Хук-«паттерн» для модалок: даёт парный `show`/`hide` и стабильный
 * компонент-обёртку `RenderModal` для размещения контента.
 *
 * Все три ссылки (`show`, `hide`, `RenderModal`) обёрнуты в `useCallback`
 * с пустыми / минимальными deps. Это критично: смена темы (или любой
 * другой ре-рендер родителя) не должна менять `RenderModal.type` —
 * иначе React размонтирует и заново монтирует `Modal`, и каждый раз
 * проигрывается входная CSS-анимация (`slideIn` контейнера и `fadeIn`
 * оверлея в `Modal/styles.ts`). По той же причине `RenderModal`
 * читает актуальный `isVisible` через `useState`-ссылку, а сам
 * `useCallback` не зависит от него.
 */
export const useModal = () => {
    const [isVisible, setIsVisible] = useState(false)

    const show = useCallback(() => {
        setIsVisible(true);
        document.body.style.overflow = 'hidden';
    }, []);

    const hide = useCallback(() => {
        setIsVisible(false);
        document.body.style.overflow = 'auto';
    }, []);

    const RenderModal = useCallback<React.FC<PropsType>>((props) => (
        <>
            {isVisible &&
                <Modal mode={props.mode}
                       closeModal={hide}
                       colorful={props.colorful}
                       unclosed={props.unclosed}>
                    {props.children}
                </Modal>}
        </>
    ), [isVisible, hide]);

    return {
        show,
        hide,
        RenderModal,
    }
}